import React from 'react';
import { TextVariant } from '@naf/text';
import { getProductNameParts } from './Summary.utils';
import * as S from './Summary.styles';

interface ProductTitleProps {
  productName: string;
  isMember: boolean;
  showNonMemberText: boolean;
}

export const ProductTitle = ({ productName, isMember, showNonMemberText }: ProductTitleProps) => {
  const { mainTitle, subTitle } = getProductNameParts(productName);

  return (
    <S.LineText variant={TextVariant.ArticleTextHeader}>
      {mainTitle}
      {subTitle && (
        <>
          <br />
          {subTitle}
        </>
      )}{' '}
      {isMember ? (
        <S.MemberText>(Medlem)</S.MemberText>
      ) : (
        showNonMemberText && <S.MemberText>(Ikke medlem)</S.MemberText>
      )}
    </S.LineText>
  );
};
